import { z } from 'zod';

export const miniPdpFormSchema = z.object({
    selectedSku: z.string().min(1, 'SKU is required'),
    fulfilmentMethod: z.enum(['bopis', 'sdd', 'sth']),
    quantity: z.number().int().positive(),
});
